import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <>
      {/* Footer Start */}
      <div className="container-fluid bg-footer  text-white mt-5">
        <div className="container">
        <div className="container">
        <div className="container">
        <div className="row gx-5">
               
                <div className="col-lg-4 col-md-12 pt-0 pt-lg-5 mb-5">
                  <h4 className="text-white mb-4">Quick Links</h4>
                  <div className="d-flex flex-column justify-content-start">
                    <Link className="text-white mb-2" to="/"><i className="fas fa-chevron-right text-white me-2"></i>Home</Link>
                    <Link className="text-white mb-2" to="/about"><i className="fas fa-chevron-right text-white me-2"></i>About Us</Link>
                    <Link className="text-white mb-2" to="/story"><i className="fas fa-chevron-right text-white me-2"></i>Our Services</Link>

                    <Link className="text-white" to="/contact"><i className="fas fa-chevron-right text-white me-2"></i>Contact Us</Link>
                  </div>
                </div>
                <div className="col-lg-4 col-md-12 pt-0 pt-lg-5 mb-5">
                  <h4 className="text-white mb-4">Popular Links</h4>
                  <div className="d-flex flex-column justify-content-start">
                    <Link className="text-white mb-2" to="/frozen-products"><i className="fas fa-chevron-right text-white me-2"></i>frozen products</Link>
                    <Link className="text-white mb-2" to="/fresh-products"><i className="fas fa-chevron-right text-white me-2"></i>Fresh products</Link>
                    <Link className="text-white mb-2" to="#"><i className="fas fa-chevron-right text-white me-2"></i>Certificate</Link>
                    <Link className="text-white mb-2" to="#"><i className="fas fa-chevron-right text-white me-2"></i>exhibition</Link>
 
                  </div>
                </div>
                <div className="col-lg-4 col-md-12 pt-5 mb-5">
                  <h4 className="text-white mb-4">Get In Touch</h4>
                  <div className="d-flex mb-2">
                    <i className="fas fa-map-marker-alt text-white me-2"></i>
                    <p className="text-white mb-0">Ademon Fremon Street, Maadi Smouha Building 2, first floor</p>
                  </div>
                  <div className="d-flex mb-2">
                    <i className="fas fa-envelope text-white me-2"></i>
                    <p className="text-white mb-0">Info@elshebany.com</p>
                  </div>
                  <div className="d-flex mb-2">
                    <i className="fas fa-phone-alt text-white me-2"></i>
                    <p className="text-white mb-0">+201553394447</p>
                  </div>
                  <div className="d-flex mt-4">
                    {/* <Link className="btn btn-secondary btn-square rounded-circle me-2" to=""><i className="fab fa-twitter"></i></Link>
                    <Link className="btn btn-secondary btn-square rounded-circle me-2" to=""><i className="fab fa-facebook-f"></i></Link> */}
                    <Link className="btn btn-secondary btn-square rounded-circle me-2" target='blank' to="https://www.linkedin.com/company/105766257/admin/dashboard/"><i className="fab fa-linkedin-in"></i></Link>
                    <Link className="btn btn-secondary btn-square rounded-circle me-2" target='blank' to="https://www.instagram.com/elshebanyfarms?igsh=MTA4cDk1OGV4bGZrNQ=="><i className="fab fa-instagram"></i></Link>
                    <Link className="btn btn-secondary btn-square rounded-circle" target='blank' to="https://www.facebook.com/share/161ZTsdJvs/"><i className="fab fa-facebook"></i></Link>
                  </div>
                </div>
              </div>
          </div>
          </div>
        </div>
      </div>
      {/* Footer End */}
    </>
  )
}
